import { z } from 'zod';

export const uploadSchema = z.object({
  file: z.instanceof(File, { message: 'File is required' }),
  ownerId: z.string().min(1, 'Owner ID is required'),
  version: z.number().int().positive('Must be a positive integer'),
});

export type UploadFormData = z.infer<typeof uploadSchema>;
